import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgPhone = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2489 13.2007L13.8347 14.6149L7.47075 8.25092L8.88496 6.83671L6.76364 4.71539L6.05654 5.4225C4.88496 6.59407 4.88496 8.49356 6.05654 9.66514L12.4205 16.0291C13.5921 17.2007 15.4916 17.2007 16.6631 16.0291L17.3702 15.322L15.2489 13.2007ZM15.2489 10.3722L20.1987 15.322L18.0774 17.4433C16.1247 19.3959 12.9589 19.3959 11.0063 17.4433L4.64232 11.0794C2.6897 9.12673 2.6897 5.9609 4.64232 4.00828L6.76364 1.88696L11.7134 6.83671L10.2992 8.25092L13.8347 11.7865L15.2489 10.3722Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgPhone);

export default ForwardRef;
